/**
 * Which `campLocations.workflowStatus` values may appear on the /welcome (location edit) route.
 * External-facing workflows (wf_external*) plus wf_internal30 (camp-managed, not searchable).
 */
export function isWelcomeRouteVisibleWorkflowStatus(
  workflowStatus: string | null | undefined
): boolean {
  if (workflowStatus == null || workflowStatus === "") {
    return false;
  }
  const s = String(workflowStatus);
  if (s === "wf_internal30") {
    return true;
  }
  return s.startsWith("wf_external");
}
